import React, { useState, useEffect } from "react";
import { usePatchDeliveryDocMutation } from "./ProcurementApiSlice";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { Tag } from 'antd';

export const DeliveryAllDoc = ({
  procCode,
  user_id,
  refetch,
  FullList,
  AddResponse,
  refetchAddResponse,
}) => {
  const [dispatchRecords, setDispatchRecords] = useState([]);
  const [patchDoc] = usePatchDeliveryDocMutation();

  const allDocumentTypes = ["quality_sheet"];
  const [selectedFiles, setSelectedFiles] = useState({});
  useEffect(() => {
    if (AddResponse !== undefined) {
      setDispatchRecords(AddResponse?.data);
    }
  }, [AddResponse]);

  const handleFileChange = (event, docType) => {
    const file = event.target.files[0];
    setSelectedFiles((prevFiles) => ({
      ...prevFiles,
      [docType]: file,
    }));
  };

  const handleUploadClick = (payloadId, Quantity) => {
    if (Object.keys(selectedFiles).length === 0) {
      swal("Select File", {
        icon: "warning",
        title: "No files selected. Please choose files to upload.",
        timer: 2000,
      });
      return; 
    }
    const formPayload = new FormData();
    formPayload.append("entity_type", "Buyer");
    formPayload.append("user_id", user_id);
    formPayload.append("category", "Procurement");
    formPayload.append("quantity", Quantity);
    Object.keys(selectedFiles).forEach((docType) => {
      formPayload.append(docType, selectedFiles[docType]);
    });
    let id = payloadId;
    patchDoc({ id, formPayload })
      .unwrap()
      .then(() => {
        toast.success("Documents Uploaded Successfully !!");
        refetch();
        refetchAddResponse();
      })
      .catch((error) => {
        toast.error(`${error.data.message}`);
      });
        setSelectedFiles({});
  };

  return (
    <div>
      {dispatchRecords?.length > 0 ? (
        <div className="status-section mb-4">
          {dispatchRecords[0]?.status && (
            <h5 className="status-header">
              Status:
              
              <Tag bordered={false} color="green">
              {dispatchRecords[0].status}
              </Tag>
            </h5>
          )}
        </div>
      ) : (
        ""
      )}
         {dispatchRecords?.length>0 &&<>
      <h4 className="text-gray">Uploaded Documents</h4>
      {/* <div
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          border: "1px solid #ddd",
        }}
      >
        <table className="table table-bordered table-hover table-striped">
          <thead className="thead-dark">
            <tr>
              <th>Quantity</th>
              <th>Remarks</th>
              <th>Uploaded Documents</th>
              <th>Upload More Documents</th>
            </tr>
          </thead>
          <tbody>
            {dispatchRecords?.map((item) =>
              item?.delivery_details?.map((dispatchRecord) => {
                const uploadedPatterns = dispatchRecord?.documents?.map(
                  (doc) => doc.pattern
                );
                const remainingDocuments = allDocumentTypes.filter(
                  (docType) => !uploadedPatterns.includes(docType)
                );
                const payloadId = dispatchRecord.id;
                const Quantity = dispatchRecord.quantity;

                return (
                  <tr key={dispatchRecord.id}>
                    <td className="align-middle text-center">
                      {dispatchRecord.quantity}
                    </td>
                    <td className="align-middle">{dispatchRecord.remark}</td>
                    <td>
                      <table className="table table-sm table-borderless">
                        <tbody>
                          {dispatchRecord.documents.map((document) => (
                            <tr key={document.id}>
                              <td className="text-center">
                                <a
                                  href={document.file}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-decoration-none"
                                >
                                  <i className="fas fa-file-pdf mr-2"></i>
                                  {document.pattern.replaceAll("_", " ")}
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                    <td>
                      {remainingDocuments.map((docType) => (
                        <div className="mt-2 text-center" key={docType}>
                          <label className="font-weight-bold">
                            {docType.replaceAll("_", "  ")}
                          </label>
                          <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) => handleFileChange(e, docType)}
                            className="form-control-file my-2"
                          />
                        </div>
                      ))}
                      <div className='text-center'>
                      <button
                        onClick={() => handleUploadClick(payloadId, Quantity)}
                        className="btn btn-primary btn-sm mt-2"
                      >
                        Upload
                      </button>
                      </div>

                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div> */}
     <div
  style={{
    maxHeight: "400px",
    overflowY: "auto",
    borderRadius: "8px",
  }}
>
  {dispatchRecords?.map((item) =>
    item?.delivery_details?.map((dispatchRecord) => {
      const uploadedPatterns = dispatchRecord?.documents?.map(
        (doc) => doc.pattern
      );
      const remainingDocuments = allDocumentTypes.filter(
        (docType) => !uploadedPatterns.includes(docType)
      );
      const payloadId = dispatchRecord.id;
      const Quantity = dispatchRecord.quantity;
      return (
        <div
          key={dispatchRecord.id}
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginBottom: "16px",
            padding: "16px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
             backgroundColor:"white"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <div>
              <strong>Quantity :</strong> {dispatchRecord.quantity} {FullList?.unit_of_measure}
            </div>
            <div>
              <strong>Remarks :</strong> {dispatchRecord.remark}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "16px",
            }}
          >
            <div style={{ flex: 1 }}>
              <strong>Uploaded Documents:</strong>
              <div style={{ marginTop: "8px" }}>
                {dispatchRecord.documents.length > 0 ? (
                  dispatchRecord.documents.map((document) => (
                    <div key={document.id}>
                      <a
                        href={document.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "#007bff",
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                     
                        {document.pattern.replaceAll("_", " ")}
                      </a>
                    </div>
                  ))
                ) : (
                  <div style={{ color: "#999" }}>No documents uploaded</div>
                )}
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <strong>Upload More Documents:</strong>
              <div style={{ marginTop: "8px" }}>
                {remainingDocuments.map((docType) => (
                  <div
                    key={docType}
                    style={{
                      marginBottom: "12px",
                    }}
                  >
                    <label style={{ fontWeight: "bold", display: "block" }}>
                      {docType.replaceAll("_", " ")}
                    </label>
                    <input
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e, docType)}
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "14px",
                      }}
                    />
                  </div>
                ))}
              </div>
              <button
                onClick={() => handleUploadClick(payloadId, Quantity)}
                className="btn btn-primary btn-sm"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      );
    })
  )}
</div>
      </>}
    </div>
  );
};
